import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AiCopilotTranslationStatusQueryVariables = Types.Exact<{
  responseId: Types.Scalars['ID']['input'];
}>;


export type AiCopilotTranslationStatusQuery = { __typename?: 'Query', aiCopilotTranslationStatus?: { __typename?: 'TranslationStatus', proofReading?: string | null, responseId: string, status: string, translation?: string | null } | null };


export const AiCopilotTranslationStatusDocument = gql`
    query aiCopilotTranslationStatus($responseId: ID!) {
  aiCopilotTranslationStatus(responseId: $responseId) {
    proofReading
    responseId
    status
    translation
  }
}
    `;

/**
 * __useAiCopilotTranslationStatusQuery__
 *
 * To run a query within a React component, call `useAiCopilotTranslationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiCopilotTranslationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiCopilotTranslationStatusQuery({
 *   variables: {
 *      responseId: // value for 'responseId'
 *   },
 * });
 */
export function useAiCopilotTranslationStatusQuery(baseOptions: Apollo.QueryHookOptions<AiCopilotTranslationStatusQuery, AiCopilotTranslationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiCopilotTranslationStatusQuery, AiCopilotTranslationStatusQueryVariables>(AiCopilotTranslationStatusDocument, options);
      }
export function useAiCopilotTranslationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiCopilotTranslationStatusQuery, AiCopilotTranslationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiCopilotTranslationStatusQuery, AiCopilotTranslationStatusQueryVariables>(AiCopilotTranslationStatusDocument, options);
        }
export function useAiCopilotTranslationStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AiCopilotTranslationStatusQuery, AiCopilotTranslationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AiCopilotTranslationStatusQuery, AiCopilotTranslationStatusQueryVariables>(AiCopilotTranslationStatusDocument, options);
        }
export type AiCopilotTranslationStatusQueryHookResult = ReturnType<typeof useAiCopilotTranslationStatusQuery>;
export type AiCopilotTranslationStatusLazyQueryHookResult = ReturnType<typeof useAiCopilotTranslationStatusLazyQuery>;
export type AiCopilotTranslationStatusSuspenseQueryHookResult = ReturnType<typeof useAiCopilotTranslationStatusSuspenseQuery>;
export type AiCopilotTranslationStatusQueryResult = Apollo.QueryResult<AiCopilotTranslationStatusQuery, AiCopilotTranslationStatusQueryVariables>;